module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/payroll-masters/allowance-codes/allowance-code-grid/allowance-code-grid.component.css
// module id = ./src/app/hrms/payroll/payroll-masters/allowance-codes/allowance-code-grid/allowance-code-grid.component.css
// module chunks = main